import { Permission } from "presentation/constant/ANAInfo/PermissionName";
import { CollectionProvider } from "presentation/store/Collection/CollectionProvider";
import { ANAInfoWrapper } from "presentation/view/components/ANAInfo/ANAInfoWrapper";
import { MessageBarWrapper } from "presentation/view/components/MessageBarWrapper";
import { CollectionMaintenance } from "presentation/view/section/Collection/CollectionMaintenance";

import { GridStyles } from "veronica-ui-component/dist/component/core/styled/table.styled";

const CollectionContMain = () => {
    return <ANAInfoWrapper permission={Permission.PAYMENT_DETAILS_MAINTENANCE}>
        <MessageBarWrapper>
            <CollectionProvider>
                <GridStyles />
                <CollectionMaintenance />
            </CollectionProvider>
        </MessageBarWrapper>
    </ANAInfoWrapper>
}

export default CollectionContMain;